<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-tittle"><span>Praise for the Writing of John J. Nance</span></p>
<p class="fm-01">“King of the modern-day aviation thriller.” —<i>Publishers Weekly</i></p>
<p class="fm-01">“Nance is a wonderful storyteller.” —<i>Chicago Tribune</i></p>
<p class="fm-02"><span><i>Final Approach</i></span></p>
<p class="fm-01">“A taut high-tech mystery that could have been written only by an airline industry insider.” —<i>New York Times</i>–bestselling author Stephen Coonts</p>
<p class="fm-02"><span><i>Scorpion Strike</i></span></p>
<p class="fm-01">“Gripping.” —<i>Seattle Post</i>-<i>Intelligencer</i></p>
<p class="fm-02"><span><i>Phoenix Rising</i></span></p>
<p class="fm-01">“Harrowing … Nance delivers suspense and smooth writing. A classy job.” —<i>The New York Times Book Review</i></p>
<p class="fm-02"><span><i>Pandora</i>’<i>s Clock</i></span></p>
<p class="fm-01">“A ticking time bomb of suspense.” —<i>Chicago Tribune</i></p>
<p class="fm-01">“A combination of <i>The Hot Zone</i> and <i>Speed.”</i> —USA Today</p>
<p class="fm-02"><span><i>Medusa’s Child</i></span></p>
<p class="fm-01">“So compelling it’s tough to look away.” —<i>People</i></p>
<p class="fm-02"><span><i>The Last Hostage</i></span></p>
<p class="fm-01">“A thrilling ride … [Will] keep even the most experienced thriller addicts strapped into their seats for the whole flight.” —<i>People</i></p>
<p class="fm-02"><span><i>Blackout</i></span></p>
<p class="fm-01">“A high tension, white knuckle thriller … Joltingly scary.” —<i>New York Post</i></p>
<p class="fm-02"><span><i>Turbulence</i></span></p>
<p class="fm-01">“Mesmerizing in-flight details [and] a compelling cast of realistic characters … once again prove John J. Nance ‘the king of the modern-day aviation thriller’.” —<i>Publishers Weekly</i></p>
<p class="fm-02"><span><i>Skyhook</i></span></p>
<p class="fm-01">“Readers are in for death-defying plane rides, lively dialogue, and realistic characters who survive crises with courage and humor.” —Associated Press</p>
<p class="fm-02"><span><i>On Shaky Ground: America’s Earthquake Alert</i></span></p>
<p class="fm-01">“Gripping! Breathlessly unrolls a succession of disasters.… If you want a literary equivalent of the quake experience, <i>On Shaky Ground</i> is the book for you.” —<i>San Francisco Examiner</i> &amp; <i>Chronicle</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?11135c53